import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MobileConsultationSections,
  UpdateMobileConsultationSections,
} from '../models/mobile-consultation-sections.model';

export interface IMobileConsultationSectionsRepository {
  get(organizationId: number): Observable<MobileConsultationSections>;
  update(
    organizationId: number,
    request: UpdateMobileConsultationSections,
  ): Observable<MobileConsultationSections>;
}

export const MOBILE_CONSULTATION_SECTIONS_REPOSITORY =
  new InjectionToken<IMobileConsultationSectionsRepository>('IMobileConsultationSectionsRepository');
